<!--
  ~ Copyright 2022 Aion Technology LLC
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~     http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="quotes mat-display-2">
  <div>
    <p>"My kids LOVE mentoring and it really has helped them with necessary skills to be successful in the classroom."</p>
    <p class="title">Parent</p>
  </div>
  <div>
    <p>"I am so glad we have a program like this available for our students. Keep up the amazing work."</p>
    <p class="title">Teacher</p>
  </div>
  <div>
    <p>"I like to read and play games with my mentor. I have to listen and follow instructions. Sometimes my mentor even wins!"</p>
    <p class="title">Student, 1st Grade</p>
  </div>
</div>
